import React, { FunctionComponent, SVGProps } from 'react'

export const IconExtensionOfRight: FunctionComponent<
  SVGProps<SVGSVGElement>
> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 1.5H10.5"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 10.5V7.5"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 9.75018C3.18365 8.29216 3.89599 6.95224 5.00194 5.98454C6.10788 5.01684 7.5305 4.48866 9 4.50018C9.97053 4.50122 10.9263 4.73767 11.7854 5.18926C12.6445 5.64084 13.3812 6.29409 13.9323 7.09295C14.4835 7.89182 14.8326 8.81245 14.9497 9.77589C15.0669 10.7393 14.9486 11.7168 14.605 12.6245C14.2614 13.5322 13.7027 14.3429 12.9769 14.9872C12.2511 15.6316 11.3798 16.0902 10.4378 16.3238C9.49579 16.5574 8.51118 16.559 7.56842 16.3285C6.62567 16.0979 5.7529 15.6421 5.025 15.0002L3 13.2002"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 12.75H3V16.5"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
